import FaiDataGrid from "components/DataGrid/FaiDataGrid";
import FaiBox from "MuiComponents/FaiBox";

function DataList(props: { data?: any; onRowClick?: any }) {
	const { data, onRowClick } = props;

	const handleRowClick = (rowData: any) => {
		if (onRowClick) {
			onRowClick(rowData);
		}
	};
	return (
		<>
			<FaiBox>
				<FaiDataGrid {...data} onRowClick={handleRowClick} />
			</FaiBox>
		</>
	);
}

export default DataList;
